let selectedPack;
let useSellingPlanTab = false;
let highestAvailablePackCount;

const showPackOption = (useSellingPlan = true) => {
  const getPacks = $(`.pack-selector-container`);

  getPacks.each(function() {
      const packOption = $(this).find(".pack-option");
  
      if (packOption.data("use-selling-plan") == useSellingPlan) {
          $(this).css("display", "flex");
      } else {
          $(this).css("display", "none");
      }
  });
}

const showSaleInfo = (
  state = false, 
  saleBadgeSelector = ".price__badge-sale", 
  slashedOffPriceSelector = "s.price-item"
) => {
  const saleBadgeEl = $(saleBadgeSelector);
  const slashedOffPriceEl = $(slashedOffPriceSelector);

  if (state) {
    saleBadgeEl.css("visibility", "visible");
    slashedOffPriceEl.css("visibility", "visible");
  } else {
    saleBadgeEl.css("visibility", "hidden");
    slashedOffPriceEl.css("visibility", "hidden");
  }

  console.log("showSaleInfo", {
    saleBadgeEl,
    slashedOffPriceEl
  });
}

window.addEventListener("DOMContentLoaded", function() {
  $(document).ready(function() {
    // Click jp-cores-attention-button-link
    const coreAttentionButton = $('#jp-cores-attention-button-link');
    coreAttentionButton.click(() => {
      const _href = coreAttentionButton.data('href');
      // console.log("#jp-cores-attention-button-link", coreAttentionButton.data('href'));
      window.open(_href, "_blank");
    });
    // Use default
    showSaleInfo();

    // Show ATC button
    const atcButton = document.querySelectorAll(".add-to-cart");
    atcButton.forEach((item, index) => {
      item.classList.add("js-loaded");
    })

    const jpErrorWarningWrapper = document.querySelectorAll(".fum-jppdp-core-wrapper");
    const jpErrorWarningCount = document.querySelectorAll(".fum-jppdp-core-count");
    
    const changeJPErrorCount = (count) => {
      // console.log("Warning Count", jpErrorWarningCount);
      jpErrorWarningCount.forEach(el => {
          el.innerText = count;
      });
    }

    const changeJPErrorWrapperDisplay = (visible) => {
      // console.log("Warning Wrapper", jpErrorWarningWrapper);
      jpErrorWarningWrapper.forEach(el => {
        if (visible) {
          el.classList.add("show");
        } else {
          el.classList.remove("show");
        }
      })
    }    
    // const accessoryWrapper = $('.fum-journeypdp-draggable');

    // const accessoryStartDragging = (e, s) => {
    //   mouseDown = true;
    //   startX = e.pageX - s.offsetLeft;
    //   scrollLeft = s.scrollLeft;
    // }
    
    // const accessoryStopDragging = (e, s) => {
    //   mouseDown = false;
    // }
    
    // const accessoryMove = (e) => {
    //   e.preventDefault();
    //   if(!mouseDown) { return; }
    //   const x = e.pageX - s.offsetLeft;
    //   const scroll = x - startX;
    //   s.scrollLeft = scrollLeft - scroll;
    // }

    // accessoryWrapper.on('mousemove', (e) => move(e));
    // accessoryWrapper.on('mousedown', (e) => accessoryStartDragging(e, this));
    // accessoryWrapper.on('mouseup', (e) => accessoryStopDragging(e, this));
    // accessoryWrapper.on('mouseleave', (e) => accessoryStopDragging(e, this));

    // slider.addEventListener('mousemove', move, false);
    // slider.addEventListener('mousedown', startDragging, false);
    // slider.addEventListener('mouseup', stopDragging, false);
    // slider.addEventListener('mouseleave', stopDragging, false);

    useSellingPlanTab = true;
    showPackOption(true);
    
    let activeJourneyPack = 0;
    let journeyPackEls = document.querySelector('.journey-pack');
    journeyPackEls = journeyPackEls.querySelectorAll('div.step');

    journeyPackEls.forEach((item, idx) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        if (event?.isTrusted === true) {
          activeJourneyPack = idx;
          updateActiveJourneyPack();
        }
        
      });
    });
    

    const updateActiveJourneyPack = () => {
      journeyPackEls.forEach((el, idx) => {
        const _inner = el.querySelector('.step-title');
          // console.log(idx, activeJourneyPack);
          
        if (idx <= activeJourneyPack) {
          _inner.style.opacity = 1;
        } else {
          _inner.style.opacity = 0.3;
        }
      })
    }

    updateActiveJourneyPack();

    // Disable scroll
    const originalScrollTo = window.scrollTo;
    const originalScrollIntoView = Element.prototype.scrollIntoView;
    
    // Disable scroll methods
    window.scrollTo = function() {};
    Element.prototype.scrollIntoView = function() {};
    
    // Re-enable scroll methods after section re-render (or after your desired action)
    $(document).on('shopify:section:load', function() {
        // Restore the original methods
        window.scrollTo = originalScrollTo;
        Element.prototype.scrollIntoView = originalScrollIntoView;
    });

    let hasSelectedDefaultPack = false;
    
    function updateAddToCartButton() {
        var step1Complete = $('.step-1').hasClass('complete');
        var step2Complete = $('.step-2').hasClass('complete');
        var step1Open = $('.step-1').find('.step-content').is('[aria-expanded="true"]');
        var step2Open = $('.step-2').find('.step-content').is('[aria-expanded="true"]');
        var totalSelected = parseInt($('.selected-pack:eq(0)').text(), 10);
        var maxPackItems = parseInt($('.max-pack:eq(0)').text(), 10);
        var buttonText;
      
        const atcButtonSelector = ".add-to-cart";
        const atcStaticText = "Add to cart";
        if (step1Open && !step1Complete) {
            buttonText = 'Select Device';
            $(atcButtonSelector).removeClass('disabled').attr('disabled', true);
            // selectDefaultPack(6);
        } else if (step1Open && step1Complete && !step2Complete) {
            buttonText = 'Select Flavor Cores';
            $(atcButtonSelector).removeClass('disabled').removeClass('outline').addClass('solid').attr('disabled', true);
            // 
        } else if (step2Open && !step2Complete) {
            buttonText = totalSelected + '/' + maxPackItems + ' selected';
            // buttonText = atcStaticText;
            $(atcButtonSelector).removeClass('disabled').removeClass('outline').addClass('solid').attr('disabled', true);
        } else if (step2Open && step2Complete) {
            buttonText = totalSelected + '/' + maxPackItems + ' selected';
            // buttonText = atcStaticText;
            $(atcButtonSelector).removeClass('disabled').removeClass('outline').addClass('solid');
            if (step1Complete) {
                // $('.add-to-cart').removeAttr('disabled');
            } else {
                $(atcButtonSelector).attr('disabled', true);
            }
        } else if (step1Complete && step2Complete && !step2Open) {
            // buttonText = 'Buy Now';
            buttonText = atcStaticText;
            // $('.add-to-cart').removeClass('disabled').removeAttr('disabled');
        } else if (step1Complete && !step2Complete && !step2Open) {
            buttonText = 'Select Flavor Cores';
            $(atcButtonSelector).removeClass('disabled').removeClass('outline').addClass('solid').attr('disabled', true);
        }

      if (step2Complete) {
        buttonText = atcStaticText;
      }
      
        if(step2Open)  $('.progress-container').show(); 
        else $('.progress-container').hide();
    
        $('.add-to-cart span:first-child').text(buttonText);

        // console.log(buttonText);
        // console.log(step1Complete && step2Complete);

        const enableATCButton = (button, is_enabled = false) => {
          if (is_enabled) {
            // If step1 and step2 are COMPLETE
            button.removeAttr('disabled');
            button.removeClass('disabled');
            button.removeClass('outline');
            button.addClass('solid');
          } else {
            button.attr('disabled', true);
            button.addClass('disabled');
            button.removeClass('solid');
            button.addClass('outline');
          }
        }
      
        const atcButtons = [$('.add-to-cart'), $('#stickyButton')];
        atcButtons.forEach((_button, idx) => {
          if (step1Complete && activeJourneyPack == 0) {
            enableATCButton(_button, true);
          } else if (step2Complete && activeJourneyPack == 1) {
            enableATCButton(_button, true);
          } else if (step1Complete && step2Complete && activeJourneyPack == 2) {
            // console.log("Trigger line 115");
            enableATCButton(_button, true);
          } else if (step1Complete && step2Complete) {
            // console.log("Trigger line 118");
            enableATCButton(_button, true);
          } else {
            // console.log("Trigger line 121");
            enableATCButton(_button, false);
          }
        })

        const getPrice = $('.total-price').text();
        // Set Price to Sticky Clone
        // $('.total-price-sticky-clone').text(getPrice);
        // console.log("Cloned Price", getPrice);
      
        setSPCoreCount(maxPackItems);
    }

    const observePriceChange = (selectorDetect, selectorReplace) => {
      var targetSpan = $(selectorDetect);
      var observer = new MutationObserver(function(mutations) {
        $(selectorReplace).html(targetSpan.html());
      });
      // Configure and start observing the target element for changes in child nodes
      var config = { childList: true, subtree: true };
      observer.observe(targetSpan[0], config);
    };

    observePriceChange('.total-price', '.total-price-sticky-clone');

    const setSPCoreCount = (packCount) => {
      const spCoreCountSubscription = $('#fum-tab-sp-corecount').text(packCount);
    }

    const setSPOgPrice = () => {
      const ogPrice = $('.total-price').data('price');
      const spCoreOrigPriceSubscription = $('#fum-tab-sp-ogprice').text(ogPrice);
    }

    const expandDefaultStep = (enable = true, defaultStepNumber = 1, stepNumberAttributeName = 'data-step-number', scrollToPosition = true) => {
        var getStepItems = document.querySelectorAll('.step > .step-content.fum-journeypdp-step-item');

        activeJourneyPack = defaultStepNumber - 1;
        updateActiveJourneyPack();
        updateAddToCartButton();
        $('.progress-container').hide();

        let currentPosition = document.body.getBoundingClientRect();

        getStepItems.forEach((item, idx) => {
          const getStepNumber = parseInt(item.getAttribute(stepNumberAttributeName));

          if (getStepNumber === defaultStepNumber) {
            item.setAttribute('aria-expanded', true);
            item.setAttribute('animating', '');
          } else {
            item.setAttribute('aria-expanded', false);
          }

          currentPosition = item.getBoundingClientRect();
          setTimeout(() => {
            item.removeAttribute('animating');
          }, 500);

          // console.log("Step Number", getStepNumber, " | TypeOf: ", typeof(item.getAttribute(stepNumberAttributeName)));
        });
        // console.log(getStepItems);

        window.scrollTo(0, 620);

        // console.log("AUTO SCROLL TO TOP");

    }

    const expandDefaultStepMultiple = (enable = true, defaultStepNumber = [1], stepNumberAttributeName = 'data-step-number', scrollToPosition = true) => {
      var getStepItems = document.querySelectorAll('.step > .step-content.fum-journeypdp-step-item');

        activeJourneyPack = defaultStepNumber[0] - 1;
        updateActiveJourneyPack();
        updateAddToCartButton();
        $('.progress-container').hide();

        let currentPosition = document.body.getBoundingClientRect();

        getStepItems.forEach((item, idx) => {
          const getStepNumber = parseInt(item.getAttribute(stepNumberAttributeName));

          if (defaultStepNumber.includes(getStepNumber)) {
            item.setAttribute('aria-expanded', true);
            item.setAttribute('animating', '');
          } else {
            item.setAttribute('aria-expanded', false);
          }

          currentPosition = item.getBoundingClientRect();
          setTimeout(() => {
            item.removeAttribute('animating');
          }, 500);

        });

        window.scrollTo(0, 620);

    }

    expandDefaultStep(true, 1);

    

      $('.step-title').click(function() {
          var step = $(this).closest('.step');
          // $('.step-content').hide();
          // $('.step-content').css('height', 0);
          // step.find('.step-content').show();
          // step.find('.step-content').css('height', '100%');
        
          $('.step-content.fum-journeypdp-step-item').attr('aria-expanded', 'false');
          step.find('.step-content.fum-journeypdp-step-item').attr('aria-expanded', 'true');
          step.find('.step-content.fum-journeypdp-step-item').attr('animating', '');
          setTimeout(() => {
             step.find('.step-content.fum-journeypdp-step-item').removeAttr('animating');
          }, 500);
          activeJourneyPack = parseInt(step.find('.step-content.fum-journeypdp-step-item').attr('data-step-number')) - 1;
          updateActiveJourneyPack();
          updateAddToCartButton();
      });

  // =========================
  // Step 1 Action Button Handler
  // This script manages the behavior of selecting buttons in Step 1 of the product form.
  // It updates the styles, text, and form input selection based on user interaction.
  // 
  // Last edited by: [Justine/H&F]
  // Last edited on: [2024-09-23]
  // =========================
    const step1ActionButtonFunc = (o) => {
      showSaleInfo(true);
      $('.step-1').addClass('complete');
      $('.step-1 .select-button').removeClass('selected');
      $('.step-1 .select-button').removeClass('solid');
      $('.step-1 .select-button').addClass('outline');
    
      $(o).removeClass('outline');
      $(o).addClass('selected');
      $(o).addClass('solid');
      $('.step-1 .select-button span:first-child').text('Select');
      $(o).find('span:first-child').text('Selected');
      $(`.product-form__input:eq(0) input[value="${$(o).closest('.device').data('name')}"]`).click();

      // Select default pack
      selectDefaultPack(6);

      step1NextFunc(1000);
    
      updateAddToCartButton();
    }
    const step1NextFunc = (t = 500) => {
      setTimeout(() => {
        changeJPErrorWrapperDisplay(true);
        expandDefaultStepMultiple(true, [2, 3]);
      }, t);
    }
    const step1WrapperSelector = '.step-1 .fum-journeypdp-variant-selectable img'
    const step1ButtonSelector = '.step-1 .select-button';
    $(step1ButtonSelector).click(function() {
        step1ActionButtonFunc(this);
    });
    $(step1WrapperSelector).click(function () {
      $(this).closest('.device').find('.select-button').trigger('click');
    });
  // =========================
  // End of Step 1 Action Button Handler
  // =========================

  // =========================
  // Step 3 Action Button Handler
  // This script manages the behavior of selecting buttons in Step 3 of the product form.
  // It updates the styles, form step completion, and form input selection based on user interaction.
  // 
  // Last edited by: [Justine/H&F]
  // Last edited on: [2024-09-23]
  // =========================
    const step3ActionButtonFunc = (o) => {
      const isSelected = $(o).hasClass('selected');
      const noAccessoryInput = $(`.product-form__input:eq(2) input[value="No Accessory"]`);
      if (isSelected) {
        // console.log('already added');
        $(o).addClass('outline');
        $(o).removeClass('solid');
        $(o).removeClass('selected');
  
        $(o).closest('.step').removeClass('complete');
  
        noAccessoryInput.click();
      } else {
        const selectButtonSelectorName = '.accessory .select-button';
        $(selectButtonSelectorName).removeClass('selected');
        $(selectButtonSelectorName).removeClass('solid');
        $(selectButtonSelectorName).addClass('outline');
      
        $(o).removeClass('outline');
        $(o).addClass('solid');
        $(o).addClass('selected');
    
        if ($('.accessory .select-button.selected').length > 0) {
            $(o).closest('.step').addClass('complete');
        } else {
            $(o).closest('.step').removeClass('complete');
        }
    
        $(`.product-form__input:eq(2) input[value="${$(o).closest('.accessory').data('name')}"]`).click();
      }
      
      updateAddToCartButton();
    }
    const step3WrapperSelector = '.step-3 .fum-journeypdp-variant-selectable img'
    $('.accessory .select-button').click(function() {
        step3ActionButtonFunc(this);
    });
    $(step3WrapperSelector).click(function () {
      $(this).closest('.accessory').find('.select-button').trigger('click');
    });
  // =========================
  // End of Step 3 Action Button Handler
  // =========================

  
  
  $('.quantity-selector').hide();

  var maxPackItems = 3;
  let totalSelectedFlavorCores = 0;

  let enableOverageLogic = true;
  function updateProgressBar() {
      var totalSelected = 0;

      $('.quantity-selector input').each(function() {
          totalSelected += parseInt($(this).val(), 10);
          // var valueCounter = $(this).siblings('.fum-quantity-counter');
          // valueCounter.text($(this).val());
      });


      totalSelected = 0;
      $('.quantity-selector input').each(function() {
          totalSelected += parseInt($(this).val(), 10);
      });

      // $('.selected-pack').text(Math.min(totalSelected, maxPackItems));
      $('.selected-pack').text(Math.min(totalSelected, maxPackItems));
      totalSelectedFlavorCores = totalSelected;
      var percentage = (totalSelected / maxPackItems) * 100;
      $('.progress').css('width', percentage + '%');

      if (totalSelected >= maxPackItems) {
          $('.step-2').addClass('complete');
        
          $('.quantity-selector input').each(function() {
              if ($(this).val() == 0) {
                  $(this).prop('disabled', true);
                  $(this).siblings('.plus-btn').prop('disabled', true);
              }
          });

          // $('.plus-btn').prop('disabled', true);
          // $('.flav-select').prop('disabled', true);
      } else {
          $('.step-2').removeClass('complete');
          $('.quantity-selector input').prop('disabled', false);
          $('.plus-btn').prop('disabled', false);
          $('.flav-select').prop('disabled', false);

          $('.quantity-selector input').each(function() {
              var currentValue = parseInt($(this).val(), 10);
              // var valueCounter = $(this).siblings('.fum-quantity-counter');
              if (currentValue >= maxPackItems) {
                  $(this).siblings('.plus-btn').prop('disabled', true);
              } else {
                  $(this).siblings('.plus-btn').prop('disabled', false);
              }
              // currentValue = parseInt($(this).val(), 10);
              // valueCounter.text($(this).val())
              // console.log("Update Quantity", currentValue);
          });
      }
    
      let _totalSelected = 0;
      $('.quantity-selector input').each(function() {
        _totalSelected += parseInt($(this).val());
        var valueCounter = $(this).siblings('.fum-quantity-counter');
        
        valueCounter.text($(this).val());
      });
      totalSelectedFlavorCores = _totalSelected;
      totalSelected = _totalSelected;
      // console.log("_totalSelected", {
      //   _totalSelected,
      //   totalSelected,
      //   totalSelectedFlavorCores
      // })

      setTimeout(() => {
        let overage = totalSelected - maxPackItems;
          if (totalSelected > maxPackItems) {
              $('.quantity-selector input').each(function() {
                  if (overage > 0) {
                      let currentValue = parseInt($(this).val(), 10);
                      if (currentValue > 0) {
                          let reduction = Math.min(currentValue, overage);
                          let newValue = currentValue - reduction;
                          $(this).val(newValue);
                          overage -= reduction;
                          if (newValue === 0) {
                              $(this).closest('.quantity-selector').hide();
                              $(this).closest('.flavor').find('.flav-select').show();
                          }
  
                          // console.log("OVERAGE INNER", {
                          //   overage,
                          //   reduction,
                          //   newValue,
                          //   currentValue
                          // })
                      }
                  }
              });
          }
      }, 500);

      // Set "count"
      // jpErrorWarningCount.innerText = maxPackItems - totalSelected;
      let flavorCountToSelect = maxPackItems - totalSelected;
      if (flavorCountToSelect <= 0) {
        flavorCountToSelect = 0;
        changeJPErrorWrapperDisplay(false);
      } else {
        changeJPErrorWrapperDisplay(true);
      }
      changeJPErrorCount(flavorCountToSelect);
      // console.log("Flavor Count to Select", {
      //   flavorCountToSelect,
      //   maxPackItems,
      //   totalSelected
      // });
      
      updateAddToCartButton();
    }

    const computeOverage = () => {
      let overage = totalSelectedFlavorCores - maxPackItems;
      if (totalSelectedFlavorCores > maxPackItems) {
          $('.quantity-selector input').each(function() {
              if (overage > 0) {
                  let currentValue = parseInt($(this).val(), 10);
                  if (currentValue > 0) {
                      let reduction = Math.min(currentValue, overage);
                      let newValue = currentValue - reduction;
                      $(this).val(newValue);
                      overage -= reduction;
                      if (newValue === 0) {
                          $(this).closest('.quantity-selector').hide();
                          $(this).closest('.flavor').find('.flav-select').show();
                      }

                      // console.log("OVERAGE INNER", {
                      //   overage,
                      //   reduction,
                      //   newValue,
                      //   currentValue
                      // })
                  }
              }
          });
      }
    }


    // Step 1: Select all elements with the class "pack-option"
    const getAllPackOptions = document.querySelectorAll(".pack-option");

    // Step 2: Initialize an empty array to store the 'data-pack' attribute values from each element
    let dataPackCountFromOptions = [];

    // Step 3: Loop through each selected element (pack-option) and extract the value of the 'data-pack' attribute
    getAllPackOptions.forEach((item, key) => {
      // Get the value of the 'data-pack' attribute for the current element
      const _packCount = parseInt(item.getAttribute("data-pack"));
      // Step 4: Add the extracted 'data-pack' value to the array (dataPackCountFromOptions)
      if (!dataPackCountFromOptions.includes(_packCount)) {
        dataPackCountFromOptions.push(_packCount);
      }
    })

    function getNextHigherValue(arr, currentValue) {
      // Sort the array in ascending order
      arr.sort((a, b) => a - b);
      
      // Find the next higher value
      const nextValue = arr.find(value => value >= currentValue);
      
      return nextValue;
    }

    function getNextLowerValue(arr, currentValue) {
      // Sort the array in descending order
      arr.sort((a, b) => b - a);
      
      // Find the next lower value
      const nextValue = arr.find(value => value <= currentValue);
      
      return nextValue;
    }

    function getValueInArray(arr, currentValue) {
      return arr.includes(currentValue) ? currentValue : null;
    }

    const autoSelectNextPack = (reverse = false) => {
      // const _totalSelected = parseInt($('.selected-pack:eq(0)').text(), 10);
      const _totalSelected = parseInt(totalSelectedFlavorCores, 10);

      console.log("autoSelectNextPack:", _totalSelected);
      
      // Step 5: Use Math.max() to find the highest value in the 'dataPackCountFromOptions' array
      // Since the array contains string values, spread the array and Math.max() will find the largest number
      const getHighestDataPackCountFromOptions = Math.max(...dataPackCountFromOptions);
      // console.log("dataPackCountFromOptions: ", dataPackCountFromOptions);
      
      // Step 6: Check if the total selected packs (_totalSelected) is greater than or equal to the maximum allowed (maxPackItems)
      // AND if it is less than the highest 'data-pack' value from the options.
      let nextHigherPack;
      let _packButtonRef;
      if (_totalSelected >= maxPackItems && _totalSelected < getHighestDataPackCountFromOptions) {
        // Step 7: If the conditions are met, find the next higher 'data-pack' value that is greater than or equal to _totalSelected
        nextHigherPack = getNextHigherValue(dataPackCountFromOptions, _totalSelected);
        
        const packOptionButton = $(`.pack-option[data-pack="${nextHigherPack}"][data-use-selling-plan="${useSellingPlanTab}"]`);
        _packButtonRef = packOptionButton;

        selectAllFlavors = false;
        packOptionButton.click()
        selectAllFlavors = true;
      } else {
        const switchPack = getValueInArray(dataPackCountFromOptions, _totalSelected);
        const packOptionButton = $(`.pack-option[data-pack="${switchPack}"][data-use-selling-plan="${useSellingPlanTab}"]`);
        _packButtonRef = packOptionButton;
        selectAllFlavors = false;
        enableOverageLogic = false;
        packOptionButton.click();
        selectAllFlavors = true;
      }

      // console.log("autoSelectNextPack:", {
      //   totalSelected: totalSelectedFlavorCores,
      //   ifGreater: _totalSelected >= maxPackItems && _totalSelected < getHighestDataPackCountFromOptions,
      //   ifSmaller: _totalSelected <= maxPackItems && _totalSelected > getHighestDataPackCountFromOptions,
      //   nextHigherPack,
      //   dataPackCountFromOptions,
      //   _packButtonRef
      // })
    }

    const flavorActionButtonFunc = (d) => {
      $(d).hide();
      var quantitySelector = $(d).siblings('.quantity-selector');
      quantitySelector.show();
      quantitySelector.find('input').val(1).change();
      updateProgressBar();
    }

    const step2WrapperSelector = '.step-2 .fum-journeypdp-variant-selectable img'
    const step2ButtonSelector = '.flav-select';
    $(step2ButtonSelector).click(function() {
        flavorActionButtonFunc(this);
    });
    $(step2WrapperSelector).click(function () {
      const findButton = $(this).siblings(step2ButtonSelector);
      findButton.click();
    });

    let selectAllFlavors = true;
    const clickPackOptionFunc = (t) => {
      $('.pack-option').removeClass('selected');
      $(t).addClass('selected');
      maxPackItems = parseInt($(t).data('pack'), 10) ?? 10;
      $('.max-pack').text(maxPackItems);
      $(`.product-form__input:eq(1) input[value="${$(t).data('pack-name')}"]`).click();
      // $(`.product-form__input:eq(1) input[value="${$(this).data('pack-name')}"]`).on('click', function(event) {
      //     event.preventDefault(); // Prevent the default action that causes scroll
      // });

      if (selectAllFlavors == true) {
        const selectAllCores = $(t).data('select-all-cores');
        // console.log("Select All Cores:", selectAllCores);
        if (selectAllCores)
        {
          const getAllCores = $('#fum-flavor-cores-step-2').children();
  
          getAllCores.each((index, item) => {
            const findButton = $(item).find('.select-button');  // Wrap the item in a jQuery object
            findButton.click(); // Uncomment this line to add the click functionality
            // console.log("Find Button:", findButton);  // Log the children of the current element
          });
        }
      }
      
      setSPCoreCount(maxPackItems);

      updateProgressBar();
    }

        $('.pack-option').click(function(e) {
            clickPackOptionFunc(this);
            // console.log("CLICK PACK OPTION");
        });

        const selectDefaultPack = (packCount, useSellingPlan = true) => {
          $(`.pack-option[data-pack="${packCount}"][data-use-selling-plan="${useSellingPlan}"]`).click();
        }

        $('.minus-btn').click(function() {
            var quantityInput = $(this).siblings('input');
            var currentValue = parseInt(quantityInput.val());

            if (currentValue > 1) {
                quantityInput.val(currentValue - 1);
            } else {
                quantityInput.val(0);
                $(this).closest('.quantity-selector').hide();
                $(this).closest('.flavor').find('.flav-select').show();
            }

            
            updateProgressBar();
            autoSelectNextPack(true); 
            
             

            // currentValue = parseInt(quantityInput.val());
            // console.log("MINUS-BTN", currentValue);
            // var valueCounter = $(this).siblings('.fum-quantity-counter');
            // valueCounter.text(currentValue);
        });

        $('.flav-select').click(() => {
          
          updateProgressBar();
          autoSelectNextPack();
        });

        $('.plus-btn').click(function() {
            var quantityInput = $(this).siblings('input');
            var currentValue = parseInt(quantityInput.val());
            const _totalSelected = parseInt(totalSelectedFlavorCores, 10);
            highestAvailablePackCount = Math.max(...dataPackCountFromOptions);

            
            if (currentValue < highestAvailablePackCount && _totalSelected < highestAvailablePackCount) {
                quantityInput.val(currentValue + 1); 

                console.log("plusBtn", {
                  quantityInput,
                  currentValue,
                  _totalSelected
                })
            }

            updateProgressBar();
            autoSelectNextPack();
          
            // currentValue = parseInt(quantityInput.val());
            // console.log("PLUS-BTN", currentValue);
            // var valueCounter = $(this).siblings('.fum-quantity-counter');
            // valueCounter.text(currentValue);
        });

        $('.quantity-selector input').on('input', function() {
            var quantity = parseInt($(this).val());
            if (quantity <= 0 || isNaN(quantity)) {
                $(this).val(0);
                $(this).closest('.quantity-selector').hide();
                $(this).closest('.flavor').find('.flav-select').show();
            } else if (quantity < maxPackItems) {
                $(this).val(quantity);
            }

            updateProgressBar();
            autoSelectNextPack();
            
        });



        $('.add-to-cart').click(function(e) {
            e.preventDefault();
          
            updateProgressBar();

          if($('.fum_tab-radio:checked').attr('id') == 'tab1-radio'){
            document.querySelector('[data-loop-widget-selling-plan-group]').click();
          } else{
                             document.querySelector('[data-loop-widget-onetime-purchase-option]').click();
          }
            const form = $('product-form.product-form form');
        
        form.find('input[name^="properties"]').remove();

            let flavorIndex = 1;
                 let childVariantLines = {};

            let bdPromoProdLines = [];
          
            $('.flavor').each(function(index) {
                const quantity = parseInt($(this).find('input[type="number"]').val(), 10);
                const flavorName = $(this).data('name');
              const flavorSku = $(this).data('sku');
              const flavorId = $(this).data('variant-id');

                if (quantity > 0) {
                    const inputIndex = flavorIndex;
                    const inputName = `properties[Flavor ${inputIndex}]`;
                    const inputValue = `${quantity}x ${flavorName}`;

                    const skuInputName = `properties[_SKU ${flavorSku}]`;
                    const skuInputValue = `${quantity}x ${flavorName}`;

                   const qtyInputName = `properties[_Quantity${inputIndex}]`;
                    const qtyInputValue = `${quantity}`;

                  
                    const hiddenInput = $('<input>', {
                        type: 'hidden',
                        name: inputName,
                        value: inputValue,
                        form: form.attr('id')
                    });
                    
                    form.append(hiddenInput);

                   const hiddenInputSku = $('<input>', {
                        type: 'hidden',
                        name: skuInputName,
                        value: skuInputValue,
                        form: form.attr('id')
                    });
                    
                    form.append(hiddenInputSku);

                   const hiddenInputQty = $('<input>', {
                        type: 'hidden',
                        name: qtyInputName,
                        value: qtyInputValue,
                        form: form.attr('id')
                    });
                    
                    form.append(hiddenInputQty);

                  
                    flavorIndex = flavorIndex + 1;
                  
                      //subscription data
                     if (childVariantLines[flavorId]) {
                    childVariantLines[flavorId] += quantity;
                    } else {
                    childVariantLines[flavorId] = quantity;
                    }
                }

                try {
                  // Boxing Day Linked Product
                  const bdPromoEnable = JSON.parse($(this).data('boxing-day-promo-enabled'));
                  const flavorBDProd = parseInt($(this).data('boxing-day-linked-product'), 10);

                  console.log("BD PROMO", bdPromoEnable);
                  
                  if (!isNaN(flavorBDProd) && bdPromoEnable) {
                    const bdPromoLineItem = {
                      id: flavorBDProd,
                      quantity: quantity
                    }
                    
                    bdPromoProdLines.push(bdPromoLineItem);
                    console.log("Linked BD Product", flavorBDProd, "Typeof", typeof(flavorBDProd));
                  }
                } catch (e) {
                  console.error("BD ERROR", e);
                }

              custom_journey_context_data.boxing_day_promo.free_gifts_lines = bdPromoProdLines;

              
            });


                  if (Object.keys(childVariantLines).length > 0) {
            const childLinesInput = $('<input>', {
                type: 'hidden',
                form: form.attr('id'),
                name: 'properties[_childLines]'
            }).val(JSON.stringify(childVariantLines));
            
            form.append(childLinesInput);
        }

          

            var step1Complete = $('.step-1').hasClass('complete');
            var step2Complete = $('.step-2').hasClass('complete');
            var step3Open = $('.step-3').find('.step-content').is('[aria-expanded="true"]');

            window.scrollTo({
                top: 620, // Vertical position in pixels
                behavior: 'smooth' // Makes the scrolling smooth
            });
  
            // console.log("AUTO SCROLL TO TOP");

            const addBoxingDayPromo = (prodLines) => {
              console.log("PROD LINES", prodLines);
              if (prodLines.length >= 1) {
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    items: prodLines
                  }),
                })
                  .then((response) => {
                    if (!response.ok) {
                      throw new Error('Failed to add item to cart');
                    }
                    refreshCartFunc();
                    
                    return response.json();
                  })
                  .then((data) => {
                    console.log('Item added to cart:', data);
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  });
  
                
                refreshCartFunc();
                console.log("BD Promo prod Lines", prodLines);
              }
            }
          
            if (totalSelectedFlavorCores >= maxPackItems) {
              if (step1Complete && step2Complete) {
                form[0].dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
              }
            
              if (activeJourneyPack == 2 && step1Complete && step2Complete && step3Open) {
                form[0].dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
              }
  
              if (activeJourneyPack == 1) {
                form[0].dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                // expandDefaultStep(true, 3);
                // console.log("EXPAND STEP 3");
              }

              setTimeout(() => {
                // addBoxingDayPromo(bdPromoProdLines);
              }, 2000);
            }

            // const _intercept = fetchInterceptor(["/cart/add", "/cart/add.js"], async ({url, options, response, intercepted}) => {
            //   console.log('Was Intercepted:', intercepted);
              
            //   if (intercepted) {
            //     addBoxingDayPromo(bdPromoProdLines);
            //   }
            // });
            // _intercept.enable();
            
        });


        window.addEventListener('scroll', () => {
            const scrollPosition = window.scrollY; // for vertical scroll
            // console.log(`Current scroll position: ${scrollPosition}`);
        });

        $(document).ready(function() {
            $('.step-navigator').on('click', function(event) {
                event.stopPropagation();
                event.preventDefault();
        
                var buttonText = $('.add-to-cart span:first-child:eq(0)').text().trim();
                if (buttonText === 'Select Device') {
                    $('.step-1 .step-title').click();
                    // $('html, body').animate({
                    //     scrollTop: $('.step-1').offset().top - 250
                    // }, 600);

                } else if (buttonText === 'Select Flavor Cores') {
                    // $('html, body').animate({
                    //     scrollTop: $('.step-2').offset().top - 250
                    // }, 600);
                    $('.step-2 .step-title').click();
                }
            });

            window.addEventListener('scroll', function() {
                // console.log('Scroll event detected at', window.scrollY);
                // console.log('Currently focused element:', document.activeElement);
            });
        });

        var selectedPack = document.querySelector('.pack-option[data-option-selected="true"]');
        if (selectedPack != null) {
          // console.log("Selected Pack: ", selectedPack.getAttribute("data-pack"));
          const packCount = selectedPack.getAttribute("data-pack");
          $(`.pack-option[data-pack="${packCount}"][data-use-selling-plan="${useSellingPlanTab}"]`).click();
        }

      


        $('.mag-pop').click(function(){

          let target = $(this).data('target');
          const magPopup = $.magnificPopup;
            magPopup.open({
            items: {
              src: target
            },
            type: 'inline',
            overflowY: 'hidden',
            callbacks: {
              open: function() {
                $('body').css('overflow', 'hidden hidden');
              },
              close: function() {
                $('body').css('overflow', '');
              }
            }
          });


        })

        $('body').on('click', (evt) => {
          const colorBg = $('.flavor-pop-container').data('text-color');
          const closeBtn = $('.mfp-close').attr('style', `color: ${colorBg} !important`);
        });


        $('body').on('click','.left-arrow, .right-arrow',function(evt){

            evt.preventDefault();
            evt.stopImmediatePropagation();

            let target = $(this).parents('.flavor-pop-container').attr('id');

            // console.log("Color Scheme", colorBg);
            // console.log(target);
            if($(this).hasClass('left-arrow')){
                if($(`[data-target="#${target}"]`).parents('.flavor').prev().length)
                $(`[data-target="#${target}"]`).parents('.flavor').prev().find('.mag-pop').click();
               else $('.flavors .flavor:last-child').find('.mag-pop').click();
            }else{
                if($(`[data-target="#${target}"]`).parents('.flavor').next().length)
                $(`[data-target="#${target}"]`).parents('.flavor').next().find('.mag-pop').click();
            else $('.flavors .flavor:first-child').find('.mag-pop').click();
            }
        });

    });

});

window.addEventListener("scroll", function() {
  var button = document.getElementById("stickyButton");
  var tabContainer = document.getElementById("fum_tab-container");
  
  var mobileButton = document.getElementById("mobileStickyButtonWrapper");
  var delievery_main =document.getElementById("custom-tabs-section");
  var buttonContainer = button.parentElement;
  var buttonPosition = buttonContainer.getBoundingClientRect().top + window.pageYOffset;
  var tabContainer = tabContainer.parentElement;
  var tabPosition = tabContainer.getBoundingClientRect().top + window.pageYOffset;
  var windowHeight = window.innerHeight;
  
  if (window.innerWidth <= 749) {
  if (window.pageYOffset + windowHeight >= buttonPosition) {
   
    // buttonContainer.style.display = "none"
    mobileButton.style.display="block"
   
  }
   if (window.pageYOffset + windowHeight >= tabPosition) {
   
    // buttonContainer.style.display = "none"
    mobileButton.style.display="block"
   
  }
  else {

        // buttonContainer.style.display = "block"
    mobileButton.style.display="none"
 
  }
  }  
});

// accessories drag scroll
// const container = document.querySelector('#accessories');
                
// let startY;
// let startX;
// let scrollLeft;
// let scrollTop;
// let isDown;

// container.addEventListener('mousedown',e => mouseIsDown(e));  
// container.addEventListener('mouseup',e => mouseUp(e))
// container.addEventListener('mouseleave',e=>mouseLeave(e));
// container.addEventListener('mousemove',e=>mouseMove(e));

// function mouseIsDown(e){
//   isDown = true;
//   container.classList.add('active'); // Change cursor to grabbing
//   startY = e.pageY - container.offsetTop;
//   startX = e.pageX - container.offsetLeft;
//   scrollLeft = container.scrollLeft;
//   scrollTop = container.scrollTop; 
// }
// function mouseUp(e){
//   isDown = false;
//    container.classList.remove('active'); // Revert cursor to grab
// }
// function mouseLeave(e){
//   isDown = false;
//    container.classList.remove('active'); // Revert cursor to grab
// }
// function mouseMove(e){
//   if(isDown){
//     e.preventDefault();
//     //Move vertcally
//     const y = e.pageY - container.offsetTop;
//     const walkY = y - startY;
//     container.scrollTop = scrollTop - walkY;

//     //Move Horizontally
//     const x = e.pageX - container.offsetLeft;
//     const walkX = x - startX;
//     container.scrollLeft = scrollLeft - walkX;

//   }
// }


// Cores tabs
document.addEventListener("DOMContentLoaded", () => {
        const defaultTabContent = document.getElementById("tab1");
        defaultTabContent.style.display = "block"; // Show default fum_tab content

        const tabLinks = document.querySelectorAll(".fum_tab");
         const flavorsContainer = document.getElementById("fum-flavor-cores-step-2");
        const flavorsTabContainer = document.getElementById("fum_tab-container");
  
        tabLinks.forEach((link) => {
          link.addEventListener("click", () => {
            const tabId = link.getAttribute("data-fum_tab");
            const radio = document.getElementById(`${tabId}-radio`);
            const tabsContainer = document.getElementById("fum_tabs");
            radio.checked = true;

            // Hide all fum_tab content
            document.querySelectorAll(".fum_tab-content").forEach((content) => {
              content.style.display = "none";
            });

            // Show the clicked fum_tab's content
            const currentTabContent = document.getElementById(tabId);
            currentTabContent.style.display = "block";

            // Reset styles for both fum_tabs
            tabLinks.forEach((fum_tab) => {
              const isTab1 = fum_tab.getAttribute("data-fum_tab") === "tab1";
              const isTab2 = fum_tab.getAttribute("data-fum_tab") === "tab2";

              

              if (isTab1) {
                fum_tab.style.backgroundColor = "#FDFCF5"; // Default for Tab 1
                fum_tab.style.border = "1.5px solid transparent";
                fum_tab.style.borderBottom = "1.5px solid #3f603f"; // Default for Tab 1
              } else if (isTab2) {
                fum_tab.style.backgroundColor = "rgba(63, 96, 63, 0.10)"; // Default for Tab 2
                fum_tab.style.border = "1.5px solid #3f603f";
                fum_tab.style.borderBottom = "transparent"; // Default for Tab 2
              }
            });

            // Apply styles based on the selected fum_tab
            if (tabId === "tab1") {
              useSellingPlanTab = true;
              
              const tab1 = document.querySelector("[data-fum_tab='tab1']");
              tab1.style.backgroundColor = "#f7f782";
              tab1.style.border = "1.5px solid #3f603f";
              tab1.style.borderBottom = "1.5px solid #f7f782";
              
              // Show before and after for Tab 1
              tab1.classList.remove("fum_tab-inactive");
              tab1.style.borderTopRightRadius = "10px";
              tab1.style.zIndex = 3;
              flavorsContainer.style.backgroundColor="#ffffc4"
              flavorsTabContainer.style.backgroundColor="#ffffc4"
              const tab2 = document.querySelector("[data-fum_tab='tab2']");
              tab2.classList.remove("fum_tab-active");
              tab2.style.zIndex = -1;
              tab2.style.backgroundColor = "#ffffc4";
              tab2.style.border = "1.5px solid transparent";
              tab2.style.borderBottom = "1.5px solid #3f603f";
              const loopSellingPlanGroup = document.querySelector('[data-loop-widget-selling-plan-group]');

              if (loopSellingPlanGroup != null) {
                loopSellingPlanGroup.click();
              }
                
            } else if (tabId === "tab2") {
              useSellingPlanTab = false;
              
              const tab1 = document.querySelector("[data-fum_tab='tab1']");
              tab1.style.backgroundColor = "#FDFCF5";
              tab1.style.border = "1.5px solid transparent";
              tab1.style.borderBottom = "1.5px solid #3f603f";
             

              // Hide before and after for Tab 1
              tab1.classList.add("fum_tab-inactive");
              tab1.style.zIndex = -1;
              const tab2 = document.querySelector("[data-fum_tab='tab2']");
              flavorsContainer.style.backgroundColor="#FDFCF5"
              flavorsTabContainer.style.backgroundColor="#FDFCF5"
              tab2.classList.add("fum_tab-active");
              tab2.style.zIndex = 3;
              tab2.style.borderTopLeftRadius = "10px";
              tab2.style.backgroundColor = "rgba(63, 96, 63, 0.10)";
              tab2.style.border = "1.5px solid #3f603f";
              tab2.style.borderBottom = "transparent";
                 document.querySelector('[data-loop-widget-onetime-purchase-option]').click();
            }

            const getSelectedPack = document.querySelector(`.pack-option.selected`);
              selectedPack = getSelectedPack.getAttribute("data-pack");
              const packOptionBtn = document.querySelector(`.pack-option[data-pack="${selectedPack}"][data-use-selling-plan="${useSellingPlanTab}"]`);
              console.log("TabControl", {
                packOptionBtn,
                selectedPack,
                useSellingPlanTab
              });
              packOptionBtn.click();
              showPackOption(useSellingPlanTab);
          });
        });
      });

//
